import React, { ReactElement } from 'react'

import Section from '@components/core/container/Section'
import Headline from '@components/core/text/Headline'
import TextBase from '@components/core/text/TextBase'
import { Breakpoint } from '@mui/material'

const kFactColors: string[] = [
  'text.primary',
  'tertiary.main',
  'secondary.main',
]

export type FactsProps = {
  theme?: MCDC.Props.ThemeType
  headline: string
  facts: string[]
  maxWidth?: Breakpoint
  sx?: MCDC.Props.IDefault['sx']
}

export default function Facts({
  theme,
  headline,
  facts = [],
  maxWidth,
  sx,
}: FactsProps): ReactElement {
  return (
    <Section
      theme={theme}
      sx={{ ...sx, backgroundColor: 'primary.main' }}
      maxWidth={maxWidth}
    >
      <Headline component="h3" variant="h5" sx={{ mb: 5 }}>
        {headline}
      </Headline>
      <Headline
        component="h2"
        variant="h2"
        sx={{
          wordWrap: 'break-word',
          '> *': {
            width: '100%',
          },
        }}
      >
        {facts.map((str, index) => (
          <TextBase
            component="span"
            variant="inherit"
            sx={{
              color:
                theme === 'primary' ? 'secondary.main' : kFactColors[index % 3],
              mr: '0.16em',
            }}
            isHtml
            key={index}
          >
            {str}
          </TextBase>
        ))}
      </Headline>
    </Section>
  )
}
